module.exports = __webpack_public_path__ + "img/item4.02d83b95.jpg";